import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'María López',
  age: 34,
  location: 'Buenos Aires, Argentina',
  quote: 'Pasé de depender 100% de clases a tener ingresos online todos los meses'
}, {
  name: 'Carlos Méndez',
  age: 41,
  location: 'Ciudad de México, México',
  quote: 'Ahora tengo alumnos que llegan solos, sin estar buscando todo el tiempo'
}, {
  name: 'Valentina Ruiz',
  age: 29,
  location: 'Bogotá, Colombia',
  quote: 'Dejé de sentir que mi ingreso tenía un techo'
}, {
  name: 'Andrés Figueroa',
  age: 38,
  location: 'Santiago, Chile',
  quote: 'En 3 meses logré crear mi primer curso y ya tengo ventas recurrentes'
}, {
  name: 'Lucía Fernández',
  age: 45,
  location: 'Madrid, España',
  quote: 'Por fin puedo enseñar italiano sin depender de mi agenda hora por hora'
}];
export function TestimonialsSection() {
  return <section className="py-20 px-4 max-w-6xl mx-auto" data-id="element-266">
      <div className="text-center mb-12" data-id="element-267">
        <span className="text-5xl mb-4 block" data-id="element-268">💬</span>
        <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-269">
          Lo que está pasando cuando aplican esto
        </h2>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-270">
        {testimonials.map((t, i) => <div key={i} className="glass-card p-6 rounded-2xl flex flex-col h-full" data-id="element-271">
            <div className="flex space-x-1 mb-4" data-id="element-272">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 text-brand-gold fill-brand-gold" data-id="element-273" />)}
            </div>
            <p className="text-lg text-gray-200 italic mb-6 flex-grow" data-id="element-274">
              "{t.quote}"
            </p>
            <div className="mt-auto pt-4 border-t border-white/10" data-id="element-275">
              <p className="text-white font-bold" data-id="element-276">
                {t.name}, {t.age}
              </p>
              <p className="text-sm text-gray-400" data-id="element-277">{t.location}</p>
            </div>
          </div>)}
      </div>
    </section>;
}